<template>
  <v-container grid-list-md>
    
    <v-layout row wrap>
      
      <v-flex xs12 class="display-1 font-weight-light">
          FLLI LEARNING LIFECYCLE
      </v-flex>

      <v-flex xs12>
          <v-img
            :src="image"
            :lazy-src="image"
          ><template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
          </v-img>
      </v-flex>

    </v-layout>
   
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        image: require('@/assets/Learning_Lifecycle_circle_v2.png')
      }
    }
  }
</script>

<style>

</style>
